import { Grid, Button, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import DoneIcon from '@mui/icons-material/Done';
import ClearIcon from '@mui/icons-material/Clear';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

// Helper component for expandable text
const ExpandableText = ({ text, limit }) => {
  const [expanded, setExpanded] = useState(false);

  if (!text || text.length <= limit) {
    return (
      <Typography variant="body2" component="span">
        {text}
      </Typography>
    );
  }

  return (
    <>
      <Typography variant="body2" component="span" sx={{ wordBreak: 'break-all' }}>
        {expanded ? text : `${text.substring(0, limit)}...`}
      </Typography>
      <Button
        size="small"
        onClick={() => setExpanded(!expanded)}
        endIcon={expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        sx={{
          textTransform: 'none',
          ml: 1,
          p: 0,
          minWidth: 'auto',
          color: '#0097DC',
          display: 'inline'
        }}>
        {expanded ? 'Show Less' : 'Show More'}
      </Button>
    </>
  );
};

const AssertionResult = (props) => {
  const errorMessage = props.error;
  const [headerAssertions, setHeaderAssertions] = useState([]);
  const [bodyAssertions, setBodyAssertions] = useState([]);

  useEffect(() => {
    if (props.assertions !== undefined) {
      let headerAsserts = [];
      let bodyAsserts = [];
      props.assertions.map((assertion) => {
        if (assertion.assertionType === 'Header_Assertion') {
          headerAsserts.push(assertion);
          setHeaderAssertions(headerAsserts);
        } else if (assertion.assertionType === 'Body_Assertion') {
          bodyAsserts.push(assertion);
          setBodyAssertions(bodyAsserts);
        }
      });
    }
  }, [props.assertions]);

  return (
    <Grid sx={{ background: 'black', borderRadius: 1, p: 2, color: 'rgba(207, 207, 207, 1)' }}>
      <Grid container>
        {!errorMessage ? (
          <Grid item xs={8} mr={1}>
            Response Time: {props.responseTime} ms
          </Grid>
        ) : (
          <Grid item xs={12} sx={{ wordBreak: 'break-all', mb: 1 }}>
            <Typography variant="body2" component="span" sx={{ fontWeight: 'bold' }}>
              Error:{' '}
            </Typography>
            <ExpandableText text={errorMessage} limit={300} />
          </Grid>
        )}
        {props.pauseDuration !== 0 && <Grid>Pause Duration: {props.pauseDuration} s</Grid>}
      </Grid>
      {props.assertions.length !== 0 && <hr style={{ background: 'grey' }} />}
      {[headerAssertions, bodyAssertions].map((assertionType, index) => {
        return (
          <Grid key={index} container sx={{ mb: 3 }}>
            {assertionType.length > 0 && (
              <>
                <Grid item sx={{ mb: 1, mr: 1 }} xs={8}>
                  {!index ? 'Header Assertions' : 'Body Assertions'}
                </Grid>
                <Grid item xs={3}>
                  Returned Value
                </Grid>
                {assertionType.map((assertion, index) => {
                  return (
                    <Grid container key={index}>
                      <Grid
                        item
                        xs={8}
                        sx={{
                          mr: 1,
                          wordBreak: 'break-all'
                        }}>
                        {assertion.field} {assertion.operator} {assertion.expectedValue}{' '}
                        {assertion.result ? (
                          <DoneIcon color="success" style={{ verticalAlign: 'middle' }} />
                        ) : (
                          <ClearIcon color="error" style={{ verticalAlign: 'middle' }} />
                        )}
                      </Grid>
                      <Grid
                        item
                        xs={3}
                        sx={{
                          wordBreak: 'break-all'
                        }}>
                        {/* Use ExpandableText component for actualValue */}
                        <ExpandableText text={assertion.actualValue} limit={100} />
                      </Grid>
                    </Grid>
                  );
                })}
              </>
            )}
          </Grid>
        );
      })}
    </Grid>
  );
};

export default AssertionResult;
